import React, { useEffect, useState } from 'react';
import { getBlockedIps, getBlockedLogins } from '../../services/api';

const CONFIG = {
  ip: {
    title: 'Blocked IP addresses',
    columnLabel: 'IP address',
    emptyMessage: 'No blocked IP addresses',
    load: getBlockedIps,
    key: 'ip',
  },
  login: {
    title: 'Blocked logins',
    columnLabel: 'Login',
    emptyMessage: 'No blocked logins',
    load: getBlockedLogins,
    key: 'login',
  },
};

const formatTimestamp = (timestamp) => new Date(timestamp * 1000).toLocaleString().replace(',', '');

const pluralize = (value, singular, plural) => (value === 1 ? singular : plural);

const formatRemainingDuration = (timestamp) => {
  const remainingMinutes = Math.max(0, Math.floor((timestamp - Math.floor(Date.now() / 1000)) / 60));
  if (remainingMinutes === 0) return 'Expires now';

  const days = Math.floor(remainingMinutes / (24 * 60));
  const hours = Math.floor((remainingMinutes % (24 * 60)) / 60);
  const minutes = remainingMinutes % 60;
  const parts = [];

  if (days) parts.push(`${days} ${pluralize(days, 'day', 'days')}`);
  if (hours) parts.push(`${hours} ${pluralize(hours, 'hour', 'hours')}`);
  if (minutes) parts.push(`${minutes} ${pluralize(minutes, 'minute', 'minutes')}`);

  return `${parts.join(' ')} remaining`;
};

function BlockedAttemptsList({ type }) {
  const config = CONFIG[type];
  const [blocks, setBlocks] = useState([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    let isCurrent = true;

    const loadBlocks = async () => {
      try {
        setLoading(true);
        setError('');
        const response = await config.load();
        if (isCurrent) setBlocks(response.data);
      } catch (err) {
        if (isCurrent) setError(err.response?.data?.error || 'Failed to load blocked attempts');
      } finally {
        if (isCurrent) setLoading(false);
      }
    };

    loadBlocks();
    return () => {
      isCurrent = false;
    };
  }, [config, refreshKey]);

  return (
    <div>
      <div className="page-header">
        <h2>{config.title}</h2>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={() => setRefreshKey((current) => current + 1)}
          disabled={loading}
        >
          Refresh
        </button>
      </div>

      {error && <div className="error" style={{ marginBottom: '15px' }}>{error}</div>}

      <div className="table-container">
        <table>
          <thead>
            <tr>
              <th>{config.columnLabel}</th>
              <th>Blocked until</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr><td colSpan="2">Loading blocked attempts...</td></tr>
            ) : blocks.length === 0 ? (
              <tr><td colSpan="2">{config.emptyMessage}</td></tr>
            ) : blocks.map((block) => (
              <tr key={block[config.key]}>
                <td>{block[config.key]}</td>
                <td>
                  <div>{formatRemainingDuration(block.lockedUntil)}</div>
                  <div className="session-secondary-text">{formatTimestamp(block.lockedUntil)}</div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default BlockedAttemptsList;
